import { CollateralTypes } from '@common/constants/client'
import { BBC_AGING_REPORT, InventoryAgingField, ReportingFlow } from '@common/interfaces/bbc'
import { SignRequest } from 'box-node-sdk/lib/schemas/signRequest'
import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'bbc'

export const SHOW_REQUEST = `${prefix}/SHOW_REQUEST`
export const SHOW_SUCCESS = `${prefix}/SHOW_SUCCESS`
export const SHOW_FAILURE = `${prefix}/SHOW_FAILURE`

export const show = createAction((id: string, params: object = {}) => ({
  type: [SHOW_REQUEST, SHOW_SUCCESS, SHOW_FAILURE],
  promise: (api: IApi) => api.bbc.show(id, params),
  params,
}))

export const HIDE = `${prefix}/HIDE`

export const hide = () => ({
  type: HIDE,
})

export const UPDATE_BBC_REQUEST = `${prefix}/UPDATE_BBC_REQUEST`
export const UPDATE_BBC_SUCCESS = `${prefix}/UPDATE_BBC_SUCCESS`
export const UPDATE_BBC_FAILURE = `${prefix}/UPDATE_BBC_FAILURE`

export const updateBBC = createAction((id: string, data: object) => ({
  type: [UPDATE_BBC_REQUEST, UPDATE_BBC_SUCCESS, UPDATE_BBC_FAILURE],
  promise: (api: IApi) => api.bbc.update(id, data),
}))

export const GET_BBC_SUMMARY_STATS_REQUEST = `${prefix}/GET_BBC_SUMMARY_STATS_REQUEST`
export const GET_BBC_SUMMARY_STATS_SUCCESS = `${prefix}/GET_BBC_SUMMARY_STATS_SUCCESS`
export const GET_BBC_SUMMARY_STATS_FAILURE = `${prefix}/GET_BBC_SUMMARY_STATS_FAILURE`

export const getBBCSummaryStats = createAction((id: string, params?: object) => ({
  type: [
    GET_BBC_SUMMARY_STATS_REQUEST,
    GET_BBC_SUMMARY_STATS_SUCCESS,
    GET_BBC_SUMMARY_STATS_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.getSummaryStats(id, params),
}))

export const GET_BBC_AR_SUMMARY_STATS_REQUEST = `${prefix}/GET_BBC_AR_SUMMARY_STATS_REQUEST`
export const GET_BBC_AR_SUMMARY_STATS_SUCCESS = `${prefix}/GET_BBC_AR_SUMMARY_STATS_SUCCESS`
export const GET_BBC_AR_SUMMARY_STATS_FAILURE = `${prefix}/GET_BBC_AR_SUMMARY_STATS_FAILURE`

export const getBBCARSummaryStats = createAction((id: string, params: object) => ({
  type: [
    GET_BBC_AR_SUMMARY_STATS_REQUEST,
    GET_BBC_AR_SUMMARY_STATS_SUCCESS,
    GET_BBC_AR_SUMMARY_STATS_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.getARSummaryStats(id, params),
  params,
}))

export const GET_BBC_AR_DETAIL_STATS_REQUEST = `${prefix}/GET_BBC_AR_DETAIL_STATS_REQUEST`
export const GET_BBC_AR_DETAIL_STATS_SUCCESS = `${prefix}/GET_BBC_AR_DETAIL_STATS_SUCCESS`
export const GET_BBC_AR_DETAIL_STATS_FAILURE = `${prefix}/GET_BBC_AR_DETAIL_STATS_FAILURE`

export const getBBCARDetailStats = createAction((id: string, params: object) => ({
  type: [
    GET_BBC_AR_DETAIL_STATS_REQUEST,
    GET_BBC_AR_DETAIL_STATS_SUCCESS,
    GET_BBC_AR_DETAIL_STATS_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.getARDetailStats(id, params),
  params,
}))

export const GET_BBC_AP_SUMMARY_STATS_REQUEST = `${prefix}/GET_BBC_AP_SUMMARY_STATS_REQUEST`
export const GET_BBC_AP_SUMMARY_STATS_SUCCESS = `${prefix}/GET_BBC_AP_SUMMARY_STATS_SUCCESS`
export const GET_BBC_AP_SUMMARY_STATS_FAILURE = `${prefix}/GET_BBC_AP_SUMMARY_STATS_FAILURE`

export const getBBCAPSummaryStats = createAction((id: string, params: object) => ({
  type: [
    GET_BBC_AP_SUMMARY_STATS_REQUEST,
    GET_BBC_AP_SUMMARY_STATS_SUCCESS,
    GET_BBC_AP_SUMMARY_STATS_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.getAPSummaryStats(id, params),
  params,
}))

export const GET_BBC_AP_DETAIL_STATS_REQUEST = `${prefix}/GET_BBC_AP_DETAIL_STATS_REQUEST`
export const GET_BBC_AP_DETAIL_STATS_SUCCESS = `${prefix}/GET_BBC_AP_DETAIL_STATS_SUCCESS`
export const GET_BBC_AP_DETAIL_STATS_FAILURE = `${prefix}/GET_BBC_AP_DETAIL_STATS_FAILURE`

export const getBBCAPDetailStats = createAction((id: string, params: object) => ({
  type: [
    GET_BBC_AP_DETAIL_STATS_REQUEST,
    GET_BBC_AP_DETAIL_STATS_SUCCESS,
    GET_BBC_AP_DETAIL_STATS_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.getAPDetailStats(id, params),
  params,
}))

export const GET_BBC_AR_AP_CHART_DATA_REQUEST = `${prefix}/GET_BBC_AR_AP_CHART_DATA_REQUEST`
export const GET_BBC_AR_AP_CHART_DATA_SUCCESS = `${prefix}/GET_BBC_AR_AP_CHART_DATA_SUCCESS`
export const GET_BBC_AR_AP_CHART_DATA_FAILURE = `${prefix}/GET_BBC_AR_AP_CHART_DATA_FAILURE`

export const getARAPChartData = createAction((id: string, params: object) => ({
  type: [
    GET_BBC_AR_AP_CHART_DATA_REQUEST,
    GET_BBC_AR_AP_CHART_DATA_SUCCESS,
    GET_BBC_AR_AP_CHART_DATA_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.getARAPChartData(id, params),
  params,
}))

const GET_AR_AP_CHART_DROPDOWN_OPTIONS = createRequestTypes(
  prefix,
  'GET_AR_AP_CHART_DROPDOWN_OPTIONS',
)
export const [
  GET_AR_AP_CHART_DROPDOWN_OPTIONS_REQUEST,
  GET_AR_AP_CHART_DROPDOWN_OPTIONS_SUCCESS,
  GET_AR_AP_CHART_DROPDOWN_OPTIONS_FAILURE,
] = GET_AR_AP_CHART_DROPDOWN_OPTIONS

export const getARAPChartDropdownOptions = createAction(
  (
    id: string,
    params: {
      agingReport: BBC_AGING_REPORT
      reportingFlow: ReportingFlow
      startDate: string
      endDate: string
    },
  ) => ({
    type: [
      GET_AR_AP_CHART_DROPDOWN_OPTIONS_REQUEST,
      GET_AR_AP_CHART_DROPDOWN_OPTIONS_SUCCESS,
      GET_AR_AP_CHART_DROPDOWN_OPTIONS_FAILURE,
    ],
    promise: (api: IApi) => api.bbc.getARAPChartDropdownOptions(id, params),
    params,
  }),
)

export const GET_BBC_AR_ROLLFORWARD_STATS_REQUEST = `${prefix}/GET_BBC_AR_ROLLFORWARD_STATS_REQUEST`
export const GET_BBC_AR_ROLLFORWARD_STATS_SUCCESS = `${prefix}/GET_BBC_AR_ROLLFORWARD_STATS_SUCCESS`
export const GET_BBC_AR_ROLLFORWARD_STATS_FAILURE = `${prefix}/GET_BBC_AR_ROLLFORWARD_STATS_FAILURE`

export const getBBCARRollforward = createAction((id: string, params: object) => ({
  type: [
    GET_BBC_AR_ROLLFORWARD_STATS_REQUEST,
    GET_BBC_AR_ROLLFORWARD_STATS_SUCCESS,
    GET_BBC_AR_ROLLFORWARD_STATS_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.getARRollforward(id, params),
  params,
}))

export const GET_BBC_AR_ROLLFORWARD_DETAILS_REQUEST = `${prefix}/GET_BBC_AR_ROLLFORWARD_DETAILS_REQUEST`
export const GET_BBC_AR_ROLLFORWARD_DETAILS_SUCCESS = `${prefix}/GET_BBC_AR_ROLLFORWARD_DETAILS_SUCCESS`
export const GET_BBC_AR_ROLLFORWARD_DETAILS_FAILURE = `${prefix}/GET_BBC_AR_ROLLFORWARD_DETAILS_FAILURE`

export const getBBCARRollforwardDetails = createAction((id: string, params: object) => ({
  type: [
    GET_BBC_AR_ROLLFORWARD_DETAILS_REQUEST,
    GET_BBC_AR_ROLLFORWARD_DETAILS_SUCCESS,
    GET_BBC_AR_ROLLFORWARD_DETAILS_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.getARRollforwardDetails(id, params),
  params,
}))

export const GET_BBC_AR_ROLLFORWARD_GRAPH_REQUEST = `${prefix}/GET_BBC_AR_ROLLFORWARD_GRAPH_REQUEST`
export const GET_BBC_AR_ROLLFORWARD_GRAPH_SUCCESS = `${prefix}/GET_BBC_AR_ROLLFORWARD_GRAPH_SUCCESS`
export const GET_BBC_AR_ROLLFORWARD_GRAPH_FAILURE = `${prefix}/GET_BBC_AR_ROLLFORWARD_GRAPH_FAILURE`

export const getBBCARRollforwardGraph = createAction((id: string, params: object) => ({
  type: [
    GET_BBC_AR_ROLLFORWARD_GRAPH_REQUEST,
    GET_BBC_AR_ROLLFORWARD_GRAPH_SUCCESS,
    GET_BBC_AR_ROLLFORWARD_GRAPH_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.getARRollforwardGraph(id, params),
  params,
}))

export const EXPORT_BBC_AR_ROLLFORWARD_REQUEST = `${prefix}/EXPORT_BBC_AR_ROLLFORWARD_REQUEST`
export const EXPORT_BBC_AR_ROLLFORWARD_SUCCESS = `${prefix}/EXPORT_BBC_AR_ROLLFORWARD_SUCCESS`
export const EXPORT_BBC_AR_ROLLFORWARD_FAILURE = `${prefix}/EXPORT_BBC_AR_ROLLFORWARD_FAILURE`

export const exportBBCARRollforward = (id: string, params: object) => ({
  type: [
    EXPORT_BBC_AR_ROLLFORWARD_REQUEST,
    EXPORT_BBC_AR_ROLLFORWARD_SUCCESS,
    EXPORT_BBC_AR_ROLLFORWARD_FAILURE,
  ],
  promise: (api: IApi) =>
    api.bbc.getARRollforward(id, {
      ...params,
      isFile: true,
    }),
  params,
})

export const GET_BBC_AP_ROLLFORWARD_STATS_REQUEST = `${prefix}/GET_BBC_AP_ROLLFORWARD_STATS_REQUEST`
export const GET_BBC_AP_ROLLFORWARD_STATS_SUCCESS = `${prefix}/GET_BBC_AP_ROLLFORWARD_STATS_SUCCESS`
export const GET_BBC_AP_ROLLFORWARD_STATS_FAILURE = `${prefix}/GET_BBC_AP_ROLLFORWARD_STATS_FAILURE`

export const getBBCAPRollforward = createAction((id: string, params: object) => ({
  type: [
    GET_BBC_AP_ROLLFORWARD_STATS_REQUEST,
    GET_BBC_AP_ROLLFORWARD_STATS_SUCCESS,
    GET_BBC_AP_ROLLFORWARD_STATS_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.getAPRollforward(id, params),
  params,
}))

export const GET_BBC_AP_ROLLFORWARD_DETAILS_REQUEST = `${prefix}/GET_BBC_AP_ROLLFORWARD_DETAILS_REQUEST`
export const GET_BBC_AP_ROLLFORWARD_DETAILS_SUCCESS = `${prefix}/GET_BBC_AP_ROLLFORWARD_DETAILS_SUCCESS`
export const GET_BBC_AP_ROLLFORWARD_DETAILS_FAILURE = `${prefix}/GET_BBC_AP_ROLLFORWARD_DETAILS_FAILURE`

export const getBBCAPRollforwardDetails = createAction((id: string, params: object) => ({
  type: [
    GET_BBC_AP_ROLLFORWARD_DETAILS_REQUEST,
    GET_BBC_AP_ROLLFORWARD_DETAILS_SUCCESS,
    GET_BBC_AP_ROLLFORWARD_DETAILS_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.getAPRollforwardDetails(id, params),
  params,
}))

export const EXPORT_BBC_AP_ROLLFORWARD_REQUEST = `${prefix}/EXPORT_BBC_AP_ROLLFORWARD_REQUEST`
export const EXPORT_BBC_AP_ROLLFORWARD_SUCCESS = `${prefix}/EXPORT_BBC_AP_ROLLFORWARD_SUCCESS`
export const EXPORT_BBC_AP_ROLLFORWARD_FAILURE = `${prefix}/EXPORT_BBC_AP_ROLLFORWARD_FAILURE`

export const exportBBCAPRollforward = (id: string, params: object) => ({
  type: [
    EXPORT_BBC_AP_ROLLFORWARD_REQUEST,
    EXPORT_BBC_AP_ROLLFORWARD_SUCCESS,
    EXPORT_BBC_AP_ROLLFORWARD_FAILURE,
  ],
  promise: (api: IApi) =>
    api.bbc.getAPRollforward(id, {
      ...params,
      isFile: true,
    }),
  params,
})

export const GET_BBC_FILES_REQUEST = `${prefix}/GET_BBC_FILES_REQUEST`
export const GET_BBC_FILES_SUCCESS = `${prefix}/GET_BBC_FILES_SUCCESS`
export const GET_BBC_FILES_FAILURE = `${prefix}/GET_BBC_FILES_FAILURE`

export const getBBCFiles = createAction((id: string) => ({
  type: [GET_BBC_FILES_REQUEST, GET_BBC_FILES_SUCCESS, GET_BBC_FILES_FAILURE],
  promise: (api: IApi) => api.bbc.getFiles(id),
}))

export const UPLOAD_BBC_FILES_REQUEST = `${prefix}/UPLOAD_BBC_FILES_REQUEST`
export const UPLOAD_BBC_FILES_SUCCESS = `${prefix}/UPLOAD_BBC_FILES_SUCCESS`
export const UPLOAD_BBC_FILES_FAILURE = `${prefix}/UPLOAD_BBC_FILES_FAILURE`

export const uploadBBCFiles = createAction((id: string, data: FormData) => ({
  type: [UPLOAD_BBC_FILES_REQUEST, UPLOAD_BBC_FILES_SUCCESS, UPLOAD_BBC_FILES_FAILURE],
  promise: (api: IApi) => api.bbc.uploadBBCFiles(id, data),
}))

export const SUBMIT_BBC_FILES_REQUEST = `${prefix}/SUBMIT_BBC_FILES_REQUEST`
export const SUBMIT_BBC_FILES_SUCCESS = `${prefix}/SUBMIT_BBC_FILES_SUCCESS`
export const SUBMIT_BBC_FILES_FAILURE = `${prefix}/SUBMIT_BBC_FILES_FAILURE`

export const submitBBCFiles = createAction((id: string, data: object) => ({
  type: [SUBMIT_BBC_FILES_REQUEST, SUBMIT_BBC_FILES_SUCCESS, SUBMIT_BBC_FILES_FAILURE],
  promise: (api: IApi) => api.bbc.submitBBCFiles(id, data),
}))

export const SUBMIT_FOR_REVIEW_REQUEST = `${prefix}/SUBMIT_FOR_REVIEW_REQUEST`
export const SUBMIT_FOR_REVIEW_SUCCESS = `${prefix}/SUBMIT_FOR_REVIEW_SUCCESS`
export const SUBMIT_FOR_REVIEW_FAILURE = `${prefix}/SUBMIT_FOR_REVIEW_FAILURE`

export const submitForReview = createAction((id: string) => ({
  type: [SUBMIT_FOR_REVIEW_REQUEST, SUBMIT_FOR_REVIEW_SUCCESS, SUBMIT_FOR_REVIEW_FAILURE],
  promise: (api: IApi) => api.bbc.submitForReview(id),
}))

export const SUBMIT_REQUEST = `${prefix}/SUBMIT_REQUEST`
export const SUBMIT_SUCCESS = `${prefix}/SUBMIT_SUCCESS`
export const SUBMIT_FAILURE = `${prefix}/SUBMIT_FAILURE`

export const submit = createAction((id: string, data: object = {}) => ({
  type: [SUBMIT_REQUEST, SUBMIT_SUCCESS, SUBMIT_FAILURE],
  promise: (api: IApi): Promise<{ data: { signObj: SignRequest } | { error: Error } }> =>
    api.bbc.submit(id, data),
}))

export const INVENTORY_INELIGIBLE_SUBMIT_REQUEST = `${prefix}/INVENTORY_INELIGIBLE_SUBMIT_REQUEST`
export const INVENTORY_INELIGIBLE_SUBMIT_SUCCESS = `${prefix}/INVENTORY_INELIGIBLE_SUBMIT_SUCCESS`
export const INVENTORY_INELIGIBLE_SUBMIT_FAILURE = `${prefix}/INVENTORY_INELIGIBLE_SUBMIT_FAILURE`

export const inventoryIneligibleSubmit = createAction((id: string) => ({
  type: [
    INVENTORY_INELIGIBLE_SUBMIT_REQUEST,
    INVENTORY_INELIGIBLE_SUBMIT_SUCCESS,
    INVENTORY_INELIGIBLE_SUBMIT_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.inventoryIneligibleSubmit(id),
}))

export const LIST_INVENTORY_INELIGIBLE_CATEGORIES_REQUEST = `${prefix}/LIST_INVENTORY_INELIGIBLE_CATEGORIES_REQUEST`
export const LIST_INVENTORY_INELIGIBLE_CATEGORIES_SUCCESS = `${prefix}/LIST_INVENTORY_INELIGIBLE_CATEGORIES_SUCCESS`
export const LIST_INVENTORY_INELIGIBLE_CATEGORIES_FAILURE = `${prefix}/LIST_INVENTORY_INELIGIBLE_CATEGORIES_FAILURE`

export const listInventoryIneligibleCategories = createAction((id: string, data: object) => ({
  type: [
    LIST_INVENTORY_INELIGIBLE_CATEGORIES_REQUEST,
    LIST_INVENTORY_INELIGIBLE_CATEGORIES_SUCCESS,
    LIST_INVENTORY_INELIGIBLE_CATEGORIES_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.listInventoryIneligibleCategories(id, data),
}))

export const LIST_MASTER_INVENTORY_REQUEST = `${prefix}/LIST_MASTER_INVENTORY_REQUEST`
export const LIST_MASTER_INVENTORY_SUCCESS = `${prefix}/LIST_MASTER_INVENTORY_SUCCESS`
export const LIST_MASTER_INVENTORY_FAILURE = `${prefix}/LIST_MASTER_INVENTORY_FAILURE`

export const listMasterInventory = createAction((id: string, data: object) => ({
  type: [
    LIST_MASTER_INVENTORY_REQUEST,
    LIST_MASTER_INVENTORY_SUCCESS,
    LIST_MASTER_INVENTORY_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.listMasterInventory(id, data),
  params: data,
}))

export const UPDATE_INVENTORY_INELIGIBLE_CATEGORIES_REQUEST = `${prefix}/UPDATE_INVENTORY_INELIGIBLE_CATEGORIES_REQUEST`
export const UPDATE_INVENTORY_INELIGIBLE_CATEGORIES_SUCCESS = `${prefix}/UPDATE_INVENTORY_INELIGIBLE_CATEGORIES_SUCCESS`
export const UPDATE_INVENTORY_INELIGIBLE_CATEGORIES_FAILURE = `${prefix}/UPDATE_INVENTORY_INELIGIBLE_CATEGORIES_FAILURE`

export const updateInventoryIneligibleCategories = createAction(
  (id: string, itemId: string, data: object) => ({
    type: [
      UPDATE_INVENTORY_INELIGIBLE_CATEGORIES_REQUEST,
      UPDATE_INVENTORY_INELIGIBLE_CATEGORIES_SUCCESS,
      UPDATE_INVENTORY_INELIGIBLE_CATEGORIES_FAILURE,
    ],
    promise: (api: IApi) => api.bbc.updateInventoryIneligibleCategories(id, itemId, data),
  }),
)

export const UPDATE_MASTER_INVENTORY_REQUEST = `${prefix}/UPDATE_MASTER_INVENTORY_REQUEST`
export const UPDATE_MASTER_INVENTORY_SUCCESS = `${prefix}/UPDATE_MASTER_INVENTORY_SUCCESS`
export const UPDATE_MASTER_INVENTORY_FAILURE = `${prefix}/UPDATE_MASTER_INVENTORY_FAILURE`

export const updateMasterInventory = createAction((id: string, itemId: string, data: object) => ({
  type: [
    UPDATE_MASTER_INVENTORY_REQUEST,
    UPDATE_MASTER_INVENTORY_SUCCESS,
    UPDATE_MASTER_INVENTORY_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.updateMasterInventory(id, itemId, data),
}))

export const ACCEPT_PREDICTED_INVENTORY_TYPE_REQUEST = `${prefix}/ACCEPT_PREDICTED_INVENTORY_TYPE_REQUEST`
export const ACCEPT_PREDICTED_INVENTORY_TYPE_SUCCESS = `${prefix}/ACCEPT_PREDICTED_INVENTORY_TYPE_SUCCESS`
export const ACCEPT_PREDICTED_INVENTORY_TYPE_FAILURE = `${prefix}/ACCEPT_PREDICTED_INVENTORY_TYPE_FAILURE`

export const acceptPredictedInventoryType = createAction((id: string, data: object) => ({
  type: [
    ACCEPT_PREDICTED_INVENTORY_TYPE_REQUEST,
    ACCEPT_PREDICTED_INVENTORY_TYPE_SUCCESS,
    ACCEPT_PREDICTED_INVENTORY_TYPE_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.acceptPredictedInventoryType(id, data),
}))

export const RETRY_INVENTORY_TYPE_PREDICTIONS_REQUEST = `${prefix}/RETRY_INVENTORY_TYPE_PREDICTIONS_REQUEST`
export const RETRY_INVENTORY_TYPE_PREDICTIONS_SUCCESS = `${prefix}/RETRY_INVENTORY_TYPE_PREDICTIONS_SUCCESS`
export const RETRY_INVENTORY_TYPE_PREDICTIONS_FAILURE = `${prefix}/RETRY_INVENTORY_TYPE_PREDICTIONS_FAILURE`

export const retryInventoryTypePredictions = createAction((id: string, data: object) => ({
  type: [
    RETRY_INVENTORY_TYPE_PREDICTIONS_REQUEST,
    RETRY_INVENTORY_TYPE_PREDICTIONS_SUCCESS,
    RETRY_INVENTORY_TYPE_PREDICTIONS_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.retryInventoryTypePredictions(id, data),
}))

export const LIST_AR_INELIGIBILITY_REQUEST = `${prefix}/LIST_AR_INELIGIBILITY_REQUEST`
export const LIST_AR_INELIGIBILITY_SUCCESS = `${prefix}/LIST_AR_INELIGIBILITY_SUCCESS`
export const LIST_AR_INELIGIBILITY_FAILURE = `${prefix}/LIST_AR_INELIGIBILITY_FAILURE`

export const listArIneligibility = createAction((id: string, data: object) => ({
  type: [
    LIST_AR_INELIGIBILITY_REQUEST,
    LIST_AR_INELIGIBILITY_SUCCESS,
    LIST_AR_INELIGIBILITY_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.listArIneligibility(id, data),
  params: data,
}))

export const UPDATE_AR_INELIGIBILITY_REQUEST = `${prefix}/UPDATE_AR_INELIGIBILITY_REQUEST`
export const UPDATE_AR_INELIGIBILITY_SUCCESS = `${prefix}/UPDATE_AR_INELIGIBILITY_SUCCESS`
export const UPDATE_AR_INELIGIBILITY_FAILURE = `${prefix}/UPDATE_AR_INELIGIBILITY_FAILURE`

export const updateArIneligibility = createAction((id: string, itemId: string, data: object) => ({
  type: [
    UPDATE_AR_INELIGIBILITY_REQUEST,
    UPDATE_AR_INELIGIBILITY_SUCCESS,
    UPDATE_AR_INELIGIBILITY_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.updateArIneligibility(id, itemId, data),
}))

export const SUBMIT_AR_INELIGIBILITY_REQUEST = `${prefix}/SUBMIT_AR_INELIGIBILITY_REQUEST`
export const SUBMIT_AR_INELIGIBILITY_SUCCESS = `${prefix}/SUBMIT_AR_INELIGIBILITY_SUCCESS`
export const SUBMIT_AR_INELIGIBILITY_FAILURE = `${prefix}/SUBMIT_AR_INELIGIBILITY_FAILURE`

export const submitArIneligibility = createAction((id: string) => ({
  type: [
    SUBMIT_AR_INELIGIBILITY_REQUEST,
    SUBMIT_AR_INELIGIBILITY_SUCCESS,
    SUBMIT_AR_INELIGIBILITY_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.submitArIneligibility(id),
}))

export const LIST_MASTER_INVOICES_BBC_REQUEST = `${prefix}/LIST_MASTER_INVOICES_BBC_REQUEST`
export const LIST_MASTER_INVOICES_BBC_SUCCESS = `${prefix}/LIST_MASTER_INVOICES_BBC_SUCCESS`
export const LIST_MASTER_INVOICES_BBC_FAILURE = `${prefix}/LIST_MASTER_INVOICES_BBC_FAILURE`

export const listMasterInvoicesBbc = createAction((id: string, data: object) => ({
  type: [
    LIST_MASTER_INVOICES_BBC_REQUEST,
    LIST_MASTER_INVOICES_BBC_SUCCESS,
    LIST_MASTER_INVOICES_BBC_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.listMasterInvoicesBbc(id, data),
  params: data,
}))

export const LIST_EXTRA_RESERVES_REQUEST = `${prefix}/LIST_EXTRA_RESERVES_REQUEST`
export const LIST_EXTRA_RESERVES_SUCCESS = `${prefix}/LIST_EXTRA_RESERVES_SUCCESS`
export const LIST_EXTRA_RESERVES_FAILURE = `${prefix}/LIST_EXTRA_RESERVES_FAILURE`

export const listExtraReserves = createAction((id: string, params?: object) => ({
  type: [LIST_EXTRA_RESERVES_REQUEST, LIST_EXTRA_RESERVES_SUCCESS, LIST_EXTRA_RESERVES_FAILURE],
  promise: (api: IApi) => api.bbc.listExtraReserves(id, params),
  params,
}))

export const UPDATE_EXTRA_RESERVES_REQUEST = `${prefix}/UPDATE_EXTRA_RESERVES_REQUEST`
export const UPDATE_EXTRA_RESERVES_SUCCESS = `${prefix}/UPDATE_EXTRA_RESERVES_SUCCESS`
export const UPDATE_EXTRA_RESERVES_FAILURE = `${prefix}/UPDATE_EXTRA_RESERVES_FAILURE`

export const CREATE_EXTRA_RESERVES_REQUEST = `${prefix}/CREATE_EXTRA_RESERVES_REQUEST`
export const CREATE_EXTRA_RESERVES_SUCCESS = `${prefix}/CREATE_EXTRA_RESERVES_SUCCESS`
export const CREATE_EXTRA_RESERVES_FAILURE = `${prefix}/CREATE_EXTRA_RESERVES_FAILURE`

export const createExtraReserves = createAction((id: string, data: object) => ({
  type: [
    CREATE_EXTRA_RESERVES_REQUEST,
    CREATE_EXTRA_RESERVES_SUCCESS,
    CREATE_EXTRA_RESERVES_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.createExtraReserves(id, data),
}))

export const updateExtraReserves = createAction((id: string, data: object) => ({
  type: [
    UPDATE_EXTRA_RESERVES_REQUEST,
    UPDATE_EXTRA_RESERVES_SUCCESS,
    UPDATE_EXTRA_RESERVES_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.updateExtraReserves(id, data),
}))

export const LIST_INVENTORY_INELIGIBLE_FIELDS_REQUEST = `${prefix}/LIST_INVENTORY_INELIGIBLE_FIELDS_REQUEST`
export const LIST_INVENTORY_INELIGIBLE_FIELDS_SUCCESS = `${prefix}/LIST_INVENTORY_INELIGIBLE_FIELDS_SUCCESS`
export const LIST_INVENTORY_INELIGIBLE_FIELDS_FAILURE = `${prefix}/LIST_INVENTORY_INELIGIBLE_FIELDS_FAILURE`

export const listFields = createAction((data: object) => ({
  type: [
    LIST_INVENTORY_INELIGIBLE_FIELDS_REQUEST,
    LIST_INVENTORY_INELIGIBLE_FIELDS_SUCCESS,
    LIST_INVENTORY_INELIGIBLE_FIELDS_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.listFields(data),
  params: data,
}))

export const CREATE_INVENTORY_INELIGIBLE_FIELDS_REQUEST = `${prefix}/CREATE_INVENTORY_INELIGIBLE_FIELDS_REQUEST`
export const CREATE_INVENTORY_INELIGIBLE_FIELDS_SUCCESS = `${prefix}/CREATE_INVENTORY_INELIGIBLE_FIELDS_SUCCESS`
export const CREATE_INVENTORY_INELIGIBLE_FIELDS_FAILURE = `${prefix}/CREATE_INVENTORY_INELIGIBLE_FIELDS_FAILURE`

export const createFields = createAction((data: object) => ({
  type: [
    CREATE_INVENTORY_INELIGIBLE_FIELDS_REQUEST,
    CREATE_INVENTORY_INELIGIBLE_FIELDS_SUCCESS,
    CREATE_INVENTORY_INELIGIBLE_FIELDS_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.createFields(data),
}))

export const UPDATE_INVENTORY_INELIGIBLE_FIELDS_REQUEST = `${prefix}/UPDATE_INVENTORY_INELIGIBLE_FIELDS_REQUEST`
export const UPDATE_INVENTORY_INELIGIBLE_FIELDS_SUCCESS = `${prefix}/UPDATE_INVENTORY_INELIGIBLE_FIELDS_SUCCESS`
export const UPDATE_INVENTORY_INELIGIBLE_FIELDS_FAILURE = `${prefix}/UPDATE_INVENTORY_INELIGIBLE_FIELDS_FAILURE`

export const updateFields = createAction((data: object) => ({
  type: [
    UPDATE_INVENTORY_INELIGIBLE_FIELDS_REQUEST,
    UPDATE_INVENTORY_INELIGIBLE_FIELDS_SUCCESS,
    UPDATE_INVENTORY_INELIGIBLE_FIELDS_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.updateFields(data),
}))

export const DELETE_INVENTORY_INELIGIBLE_FIELDS_REQUEST = `${prefix}/DELETE_INVENTORY_INELIGIBLE_FIELDS_REQUEST`
export const DELETE_INVENTORY_INELIGIBLE_FIELDS_SUCCESS = `${prefix}/DELETE_INVENTORY_INELIGIBLE_FIELDS_SUCCESS`
export const DELETE_INVENTORY_INELIGIBLE_FIELDS_FAILURE = `${prefix}/DELETE_INVENTORY_INELIGIBLE_FIELDS_FAILURE`

export const deleteField = createAction((id: string, data: object) => ({
  type: [
    DELETE_INVENTORY_INELIGIBLE_FIELDS_REQUEST,
    DELETE_INVENTORY_INELIGIBLE_FIELDS_SUCCESS,
    DELETE_INVENTORY_INELIGIBLE_FIELDS_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.deleteField(id, data),
}))

export const LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_REQUEST = `${prefix}/LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_REQUEST`
export const LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_SUCCESS = `${prefix}/LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_SUCCESS`
export const LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_FAILURE = `${prefix}/LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_FAILURE`

export const listCustomRules = createAction((data: object) => ({
  type: [
    LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_REQUEST,
    LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_SUCCESS,
    LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.listCustomRules(data),
  params: data,
}))

export const CREATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_REQUEST = `${prefix}/CREATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_REQUEST`
export const CREATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_SUCCESS = `${prefix}/CREATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_SUCCESS`
export const CREATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_FAILURE = `${prefix}/CREATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_FAILURE`

export const createCustomRules = createAction((data: object) => ({
  type: [
    CREATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_REQUEST,
    CREATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_SUCCESS,
    CREATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.createCustomRules(data),
}))

export const UPDATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_REQUEST = `${prefix}/UPDATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_REQUEST`
export const UPDATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_SUCCESS = `${prefix}/UPDATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_SUCCESS`
export const UPDATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_FAILURE = `${prefix}/UPDATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_FAILURE`

export const updateCustomRule = createAction((id: string, data: object) => ({
  type: [
    UPDATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_REQUEST,
    UPDATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_SUCCESS,
    UPDATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.updateCustomRule(id, data),
}))

export const DELETE_INVENTORY_INELIGIBLE_CUSTOM_RULES_REQUEST = `${prefix}/DELETE_INVENTORY_INELIGIBLE_CUSTOM_RULES_REQUEST`
export const DELETE_INVENTORY_INELIGIBLE_CUSTOM_RULES_SUCCESS = `${prefix}/DELETE_INVENTORY_INELIGIBLE_CUSTOM_RULES_SUCCESS`
export const DELETE_INVENTORY_INELIGIBLE_CUSTOM_RULES_FAILURE = `${prefix}/DELETE_INVENTORY_INELIGIBLE_CUSTOM_RULES_FAILURE`

export const deleteCustomRule = createAction((id: string, data: object) => ({
  type: [
    DELETE_INVENTORY_INELIGIBLE_CUSTOM_RULES_REQUEST,
    DELETE_INVENTORY_INELIGIBLE_CUSTOM_RULES_SUCCESS,
    DELETE_INVENTORY_INELIGIBLE_CUSTOM_RULES_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.deleteCustomRule(id, data),
}))

export const LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_LABELS_REQUEST = `${prefix}/LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_LABELS_REQUEST`
export const LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_LABELS_SUCCESS = `${prefix}/LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_LABELS_SUCCESS`
export const LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_LABELS_FAILURE = `${prefix}/LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_LABELS_FAILURE`

export const listCustomRulesLabels = createAction(() => ({
  type: [
    LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_LABELS_REQUEST,
    LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_LABELS_SUCCESS,
    LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_LABELS_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.listCustomRulesLabels(),
}))

export const CREATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_LABELS_REQUEST = `${prefix}/CREATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_LABELS_REQUEST`
export const CREATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_LABELS_SUCCESS = `${prefix}/CREATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_LABELS_SUCCESS`
export const CREATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_LABELS_FAILURE = `${prefix}/CREATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_LABELS_FAILURE`

export const createCustomRulesLabel = createAction((data: object) => ({
  type: [
    CREATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_LABELS_REQUEST,
    CREATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_LABELS_SUCCESS,
    CREATE_INVENTORY_INELIGIBLE_CUSTOM_RULES_LABELS_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.createCustomRulesLabel(data),
}))

export const LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_VALUES_REQUEST = `${prefix}/LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_VALUES_REQUEST`
export const LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_VALUES_SUCCESS = `${prefix}/LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_VALUES_SUCCESS`
export const LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_VALUES_FAILURE = `${prefix}/LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_VALUES_FAILURE`

export const listCustomRulesValues = createAction(
  (data: { clientName: string; field: string; borrowingBaseId?: string }) => ({
    type: [
      LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_VALUES_REQUEST,
      LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_VALUES_SUCCESS,
      LIST_INVENTORY_INELIGIBLE_CUSTOM_RULES_VALUES_FAILURE,
    ],
    promise: (api: IApi) => api.bbc.listCustomRulesValues(data),
    field: data.field,
  }),
)

export const LIST_INVENTORY_DISTRIBUTION_ANALYSIS_TYPE_REQUEST = `${prefix}/LIST_INVENTORY_DISTRIBUTION_ANALYSIS_TYPE_REQUEST`
export const LIST_INVENTORY_DISTRIBUTION_ANALYSIS_TYPE_SUCCESS = `${prefix}/LIST_INVENTORY_DISTRIBUTION_ANALYSIS_TYPE_SUCCESS`
export const LIST_INVENTORY_DISTRIBUTION_ANALYSIS_TYPE_FAILURE = `${prefix}/LIST_INVENTORY_DISTRIBUTION_ANALYSIS_TYPE_FAILURE`

export const listInventoryDistributionAnalysis = createAction((id: string, data: object) => ({
  type: [
    LIST_INVENTORY_DISTRIBUTION_ANALYSIS_TYPE_REQUEST,
    LIST_INVENTORY_DISTRIBUTION_ANALYSIS_TYPE_SUCCESS,
    LIST_INVENTORY_DISTRIBUTION_ANALYSIS_TYPE_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.listInventoryDistributionAnalysis(id, data),
}))

export const LIST_INVENTORY_AGING_DISTRIBUTION_REQUEST = `${prefix}/LIST_INVENTORY_AGING_DISTRIBUTION_REQUEST`
export const LIST_INVENTORY_AGING_DISTRIBUTION_SUCCESS = `${prefix}/LIST_INVENTORY_AGING_DISTRIBUTION_SUCCESS`
export const LIST_INVENTORY_AGING_DISTRIBUTION_FAILURE = `${prefix}/LIST_INVENTORY_AGING_DISTRIBUTION_FAILURE`

/**
 * The aging exhibits hit the same endpoint as the distribution table but land in their own
 * per-field slot: `inventoryDistributionData` is a single slot, and the Inventory tab renders
 * the table alongside both aging charts, which would otherwise overwrite one another.
 */
export const listInventoryAgingDistribution = createAction(
  (id: string, params: { field: InventoryAgingField } & Record<string, unknown>) => ({
    type: [
      LIST_INVENTORY_AGING_DISTRIBUTION_REQUEST,
      LIST_INVENTORY_AGING_DISTRIBUTION_SUCCESS,
      LIST_INVENTORY_AGING_DISTRIBUTION_FAILURE,
    ],
    promise: (api: IApi) => api.bbc.listInventoryDistributionAnalysis(id, params),
    params,
  }),
)

export const LIST_INVENTORY_DISTRIBUTION_ANALYSIS_CATEGORIES_REQUEST = `${prefix}/LIST_INVENTORY_DISTRIBUTION_ANALYSIS_CATEGORIES_REQUEST`
export const LIST_INVENTORY_DISTRIBUTION_ANALYSIS_CATEGORIES_SUCCESS = `${prefix}/LIST_INVENTORY_DISTRIBUTION_ANALYSIS_CATEGORIES_SUCCESS`
export const LIST_INVENTORY_DISTRIBUTION_ANALYSIS_CATEGORIES_FAILURE = `${prefix}/LIST_INVENTORY_DISTRIBUTION_ANALYSIS_CATEGORIES_FAILURE`

export const listInventoryDistributionAnalysisCategories = createAction(
  (id: string, data: object) => ({
    type: [
      LIST_INVENTORY_DISTRIBUTION_ANALYSIS_CATEGORIES_REQUEST,
      LIST_INVENTORY_DISTRIBUTION_ANALYSIS_CATEGORIES_SUCCESS,
      LIST_INVENTORY_DISTRIBUTION_ANALYSIS_CATEGORIES_FAILURE,
    ],
    promise: (api: IApi) => api.bbc.listInventoryDistributionAnalysisCategories(id, data),
  }),
)

export const LIST_INVENTORY_INELIGIBLE_STATS_SUMMARY_REQUEST = `${prefix}/LIST_INVENTORY_INELIGIBLE_SUMMARY_STATS_REQUEST`
export const LIST_INVENTORY_INELIGIBLE_STATS_SUMMARY_SUCCESS = `${prefix}/LIST_INVENTORY_INELIGIBLE_SUMMARY_STATS_SUCCESS`
export const LIST_INVENTORY_INELIGIBLE_STATS_SUMMARY_FAILURE = `${prefix}/LIST_INVENTORY_INELIGIBLE_SUMMARY_STATS_FAILURE`

export const listInventoryIneligibleStatsSummary = createAction((id: string, data?: object) => ({
  type: [
    LIST_INVENTORY_INELIGIBLE_STATS_SUMMARY_REQUEST,
    LIST_INVENTORY_INELIGIBLE_STATS_SUMMARY_SUCCESS,
    LIST_INVENTORY_INELIGIBLE_STATS_SUMMARY_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.listInventoryIneligibleStatsSummary(id, data),
  params: data,
}))

export const LIST_INVENTORY_INELIGIBLE_STATS_REASON_REQUEST = `${prefix}/LIST_INVENTORY_INELIGIBLE_STATS_REASON_REQUEST`
export const LIST_INVENTORY_INELIGIBLE_STATS_REASON_SUCCESS = `${prefix}/LIST_INVENTORY_INELIGIBLE_STATS_REASON_SUCCESS`
export const LIST_INVENTORY_INELIGIBLE_STATS_REASON_FAILURE = `${prefix}/LIST_INVENTORY_INELIGIBLE_STATS_REASON_FAILURE`

export const listInventoryIneligibleStatsReason = createAction((id: string, data?: object) => ({
  type: [
    LIST_INVENTORY_INELIGIBLE_STATS_REASON_REQUEST,
    LIST_INVENTORY_INELIGIBLE_STATS_REASON_SUCCESS,
    LIST_INVENTORY_INELIGIBLE_STATS_REASON_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.listInventoryIneligibleStatsReason(id, data),
  params: data,
}))

export const LIST_INVENTORY_INELIGIBLE_STATS_DETAIL_REQUEST = `${prefix}/LIST_INVENTORY_INELIGIBLE_STATS_DETAIL_REQUEST`
export const LIST_INVENTORY_INELIGIBLE_STATS_DETAIL_SUCCESS = `${prefix}/LIST_INVENTORY_INELIGIBLE_STATS_DETAIL_SUCCESS`
export const LIST_INVENTORY_INELIGIBLE_STATS_DETAIL_FAILURE = `${prefix}/LIST_INVENTORY_INELIGIBLE_STATS_DETAIL_FAILURE`

export const listInventoryIneligibleStatsDetail = createAction((id: string, data?: object) => ({
  type: [
    LIST_INVENTORY_INELIGIBLE_STATS_DETAIL_REQUEST,
    LIST_INVENTORY_INELIGIBLE_STATS_DETAIL_SUCCESS,
    LIST_INVENTORY_INELIGIBLE_STATS_DETAIL_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.listInventoryIneligibleStatsDetail(id, data),
  params: data,
}))

export const LIST_AR_INELIGIBLE_STATS_REQUEST = `${prefix}/LIST_AR_INELIGIBLE_STATS_REQUEST`
export const LIST_AR_INELIGIBLE_STATS_SUCCESS = `${prefix}/LIST_AR_INELIGIBLE_STATS_SUCCESS`
export const LIST_AR_INELIGIBLE_STATS_FAILURE = `${prefix}/LIST_AR_INELIGIBLE_STATS_FAILURE`

export const listARIneligibleStats = createAction((id: string, params?: object) => ({
  type: [
    LIST_AR_INELIGIBLE_STATS_REQUEST,
    LIST_AR_INELIGIBLE_STATS_SUCCESS,
    LIST_AR_INELIGIBLE_STATS_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.listARIneligibleStats(id, params),
  params,
}))
export const LIST_AR_INELIGIBLE_STATS_DETAILS_REQUEST = `${prefix}/LIST_AR_INELIGIBLE_STATS_DETAILS_REQUEST`
export const LIST_AR_INELIGIBLE_STATS_DETAILS_SUCCESS = `${prefix}/LIST_AR_INELIGIBLE_STATS_DETAILS_SUCCESS`
export const LIST_AR_INELIGIBLE_STATS_DETAILS_FAILURE = `${prefix}/LIST_AR_INELIGIBLE_STATS_DETAILS_FAILURE`

export const listArIneligibleStatsDetails = createAction((id: string, params?: object) => ({
  type: [
    LIST_AR_INELIGIBLE_STATS_DETAILS_REQUEST,
    LIST_AR_INELIGIBLE_STATS_DETAILS_SUCCESS,
    LIST_AR_INELIGIBLE_STATS_DETAILS_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.listArIneligibleStatsDetails(id, params),
  params,
}))
export const LIST_AR_INELIGIBLE_STATS_DETAILS_INVOICES_REQUEST = `${prefix}/LIST_AR_INELIGIBLE_STATS_DETAILS_INVOICES_REQUEST`
export const LIST_AR_INELIGIBLE_STATS_DETAILS_INVOICES_SUCCESS = `${prefix}/LIST_AR_INELIGIBLE_STATS_DETAILS_INVOICES_SUCCESS`
export const LIST_AR_INELIGIBLE_STATS_DETAILS_INVOICES_FAILURE = `${prefix}/LIST_AR_INELIGIBLE_STATS_DETAILS_INVOICES_FAILURE`

export const listArIneligibleStatsDetailsInvoices = createAction((id: string, params?: object) => ({
  type: [
    LIST_AR_INELIGIBLE_STATS_DETAILS_INVOICES_REQUEST,
    LIST_AR_INELIGIBLE_STATS_DETAILS_INVOICES_SUCCESS,
    LIST_AR_INELIGIBLE_STATS_DETAILS_INVOICES_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.listArIneligibleStatsDetailsInvoices(id, params),
  params,
}))

export const LIST_INELIGIBLE_INVOICES_REQUEST = `${prefix}/LIST_INELIGIBLE_INVOICES_REQUEST`
export const LIST_INELIGIBLE_INVOICES_SUCCESS = `${prefix}/LIST_INELIGIBLE_INVOICES_SUCCESS`
export const LIST_INELIGIBLE_INVOICES_FAILURE = `${prefix}/LIST_INELIGIBLE_INVOICES_FAILURE`

export const listIneligibleInvoices = createAction((id: string, params?: object) => ({
  type: [
    LIST_INELIGIBLE_INVOICES_REQUEST,
    LIST_INELIGIBLE_INVOICES_SUCCESS,
    LIST_INELIGIBLE_INVOICES_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.listIneligibleInvoices(id, params),
  params,
}))

export const GET_PREVIOUS_CLIENT_COLLATERALS_REQUEST = `${prefix}/GET_PREVIOUS_CLIENT_COLLATERALS_REQUEST`
export const GET_PREVIOUS_CLIENT_COLLATERALS_SUCCESS = `${prefix}/GET_PREVIOUS_CLIENT_COLLATERALS_SUCCESS`
export const GET_PREVIOUS_CLIENT_COLLATERALS_FAILURE = `${prefix}/GET_PREVIOUS_CLIENT_COLLATERALS_FAILURE`

export const getPreviousBBCClientCollateral = createAction((id: string, params?: object) => ({
  type: [
    GET_PREVIOUS_CLIENT_COLLATERALS_REQUEST,
    GET_PREVIOUS_CLIENT_COLLATERALS_SUCCESS,
    GET_PREVIOUS_CLIENT_COLLATERALS_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.getPreviousBBCClientCollateral(id, params),
  params,
}))

export const CALCULATE_CLIENT_COLLATERAL_REQUEST = `${prefix}/CALCULATE_CLIENT_COLLATERAL_REQUEST`
export const CALCULATE_CLIENT_COLLATERAL_SUCCESS = `${prefix}/CALCULATE_CLIENT_COLLATERAL_SUCCESS`
export const CALCULATE_CLIENT_COLLATERAL_FAILURE = `${prefix}/CALCULATE_CLIENT_COLLATERAL_FAILURE`

export interface ICalculateClientCollateralParams {
  /** The eligibility revision the calculation's inputs were read at, when that preceded the
   * request (e.g. ineligibility submits run first). Defaults to the revision at request time. */
  eligibilityRevision?: number
}

export const calculateClientCollateral = createAction(
  (id: string, params: ICalculateClientCollateralParams = {}) => ({
    type: [
      CALCULATE_CLIENT_COLLATERAL_REQUEST,
      CALCULATE_CLIENT_COLLATERAL_SUCCESS,
      CALCULATE_CLIENT_COLLATERAL_FAILURE,
    ],
    promise: (api: IApi) => api.bbc.calculateClientCollateral(id),
    params,
  }),
)

export const EXPORT_BBC_REQUEST = `${prefix}/EXPORT_BBC_REQUEST`
export const EXPORT_BBC_SUCCESS = `${prefix}/EXPORT_BBC_SUCCESS`
export const EXPORT_BBC_FAILURE = `${prefix}/EXPORT_BBC_FAILURE`

export const exportBBC = createAction((id: string, clientName: string, recordDate: string) => ({
  type: [EXPORT_BBC_REQUEST, EXPORT_BBC_SUCCESS, EXPORT_BBC_FAILURE],
  promise: (api: IApi) => api.bbc.export(id),
  clientName,
  recordDate,
}))

export const UPDATE_BBC_PDF_REQUEST = `${prefix}/UPDATE_BBC_PDF_REQUEST`
export const UPDATE_BBC_PDF_SUCCESS = `${prefix}/UPDATE_BBC_PDF_SUCCESS`
export const UPDATE_BBC_PDF_FAILURE = `${prefix}/UPDATE_BBC_PDF_FAILURE`

export const updateBBCPdf = createAction((id: string) => ({
  type: [UPDATE_BBC_PDF_REQUEST, UPDATE_BBC_PDF_SUCCESS, UPDATE_BBC_PDF_FAILURE],
  promise: (api: IApi) => api.bbc.updatePDF(id),
}))

export const DOWNLOAD_TEMPLATE_REQUEST = `${prefix}/DOWNLOAD_TEMPLATE_REQUEST`
export const DOWNLOAD_TEMPLATE_SUCCESS = `${prefix}/DOWNLOAD_TEMPLATE_SUCCESS`
export const DOWNLOAD_TEMPLATE_FAILURE = `${prefix}/DOWNLOAD_TEMPLATE_FAILURE`

export const downloadTemplate = createAction((fileType?: string, fileId?: string) => ({
  type: [DOWNLOAD_TEMPLATE_REQUEST, DOWNLOAD_TEMPLATE_SUCCESS, DOWNLOAD_TEMPLATE_FAILURE],
  promise: (api: IApi) => api.bbc.downloadTemplate(fileType, fileId),
}))

export const LIST_BBC_RESERVE_REQUEST = `${prefix}/LIST_BBC_RESERVE_REQUEST`
export const LIST_BBC_RESERVE_SUCCESS = `${prefix}/LIST_BBC_RESERVE_SUCCESS`
export const LIST_BBC_RESERVE_FAILURE = `${prefix}/LIST_BBC_RESERVE_FAILURE`

/** `type` routes each reserve request to its own bucket of the keyed `reserves` slice. */
interface IReserveParams {
  type: CollateralTypes
  skipLoader?: boolean
}

export interface IReserveMutationData {
  type: CollateralTypes
  [field: string]: unknown
}

export const listBBCReserves = createAction((id: string, data: IReserveParams) => ({
  type: [LIST_BBC_RESERVE_REQUEST, LIST_BBC_RESERVE_SUCCESS, LIST_BBC_RESERVE_FAILURE],
  promise: (api: IApi) => api.bbc.listBBCReserves(id, data),
  params: data,
}))

export const CREATE_BBC_RESERVE_REQUEST = `${prefix}/CREATE_BBC_RESERVE_REQUEST`
export const CREATE_BBC_RESERVE_SUCCESS = `${prefix}/CREATE_BBC_RESERVE_SUCCESS`
export const CREATE_BBC_RESERVE_FAILURE = `${prefix}/CREATE_BBC_RESERVE_FAILURE`

export const createBBCReserve = createAction((id: string, data: IReserveMutationData) => ({
  type: [CREATE_BBC_RESERVE_REQUEST, CREATE_BBC_RESERVE_SUCCESS, CREATE_BBC_RESERVE_FAILURE],
  promise: (api: IApi) => api.bbc.createBBCReserve(id, data),
  params: { type: data.type },
}))

export const UPDATE_BBC_RESERVE_REQUEST = `${prefix}/UPDATE_BBC_RESERVE_REQUEST`
export const UPDATE_BBC_RESERVE_SUCCESS = `${prefix}/UPDATE_BBC_RESERVE_SUCCESS`
export const UPDATE_BBC_RESERVE_FAILURE = `${prefix}/UPDATE_BBC_RESERVE_FAILURE`

export const updateBBCReserve = createAction(
  (id: string, itemId: string, data: IReserveMutationData) => ({
    type: [UPDATE_BBC_RESERVE_REQUEST, UPDATE_BBC_RESERVE_SUCCESS, UPDATE_BBC_RESERVE_FAILURE],
    promise: (api: IApi) => api.bbc.updateBBCReserve(id, itemId, data),
    params: { type: data.type },
  }),
)

export const DELETE_BBC_RESERVE_REQUEST = `${prefix}/DELETE_BBC_RESERVE_REQUEST`
export const DELETE_BBC_RESERVE_SUCCESS = `${prefix}/DELETE_BBC_RESERVE_SUCCESS`
export const DELETE_BBC_RESERVE_FAILURE = `${prefix}/DELETE_BBC_RESERVE_FAILURE`

export const deleteBBCReserve = createAction(
  (id: string, itemId: string, type: CollateralTypes) => ({
    type: [DELETE_BBC_RESERVE_REQUEST, DELETE_BBC_RESERVE_SUCCESS, DELETE_BBC_RESERVE_FAILURE],
    promise: (api: IApi) => api.bbc.deleteBBCReserve(id, itemId),
    params: { type },
  }),
)

export const DELETE_ALL_BBC_RESERVES_REQUEST = `${prefix}/DELETE_ALL_BBC_RESERVES_REQUEST`
export const DELETE_ALL_BBC_RESERVES_SUCCESS = `${prefix}/DELETE_ALL_BBC_RESERVES_SUCCESS`
export const DELETE_ALL_BBC_RESERVES_FAILURE = `${prefix}/DELETE_ALL_BBC_RESERVES_FAILURE`

export const deleteAllBBCReserves = createAction((id: string, type: CollateralTypes) => ({
  type: [
    DELETE_ALL_BBC_RESERVES_REQUEST,
    DELETE_ALL_BBC_RESERVES_SUCCESS,
    DELETE_ALL_BBC_RESERVES_FAILURE,
  ],
  promise: (api: IApi) => api.bbc.deleteAllBBCReserves(id, type),
  params: { type },
}))

export const LIST_CLIENT_RESERVE_REQUEST = `${prefix}/LIST_CLIENT_RESERVE_REQUEST`
export const LIST_CLIENT_RESERVE_SUCCESS = `${prefix}/LIST_CLIENT_RESERVE_SUCCESS`
export const LIST_CLIENT_RESERVE_FAILURE = `${prefix}/LIST_CLIENT_RESERVE_FAILURE`

export const listClientReserves = createAction((id: string, data: IReserveParams) => ({
  type: [LIST_CLIENT_RESERVE_REQUEST, LIST_CLIENT_RESERVE_SUCCESS, LIST_CLIENT_RESERVE_FAILURE],
  promise: (api: IApi) => api.clientInfo.listOtherReserves(id, data),
  params: data,
}))

export const CREATE_CLIENT_RESERVE_REQUEST = `${prefix}/CREATE_CLIENT_RESERVE_REQUEST`
export const CREATE_CLIENT_RESERVE_SUCCESS = `${prefix}/CREATE_CLIENT_RESERVE_SUCCESS`
export const CREATE_CLIENT_RESERVE_FAILURE = `${prefix}/CREATE_CLIENT_RESERVE_FAILURE`

export const createClientReserve = createAction((id: string, data: IReserveMutationData) => ({
  type: [
    CREATE_CLIENT_RESERVE_REQUEST,
    CREATE_CLIENT_RESERVE_SUCCESS,
    CREATE_CLIENT_RESERVE_FAILURE,
  ],
  promise: (api: IApi) => api.clientInfo.createOtherReserve(id, data),
  params: { type: data.type },
}))

export const UPDATE_CLIENT_RESERVE_REQUEST = `${prefix}/UPDATE_CLIENT_RESERVE_REQUEST`
export const UPDATE_CLIENT_RESERVE_SUCCESS = `${prefix}/UPDATE_CLIENT_RESERVE_SUCCESS`
export const UPDATE_CLIENT_RESERVE_FAILURE = `${prefix}/UPDATE_CLIENT_RESERVE_FAILURE`

export const updateClientReserve = createAction(
  (id: string, itemId: string, data: IReserveMutationData) => ({
    type: [
      UPDATE_CLIENT_RESERVE_REQUEST,
      UPDATE_CLIENT_RESERVE_SUCCESS,
      UPDATE_CLIENT_RESERVE_FAILURE,
    ],
    promise: (api: IApi) => api.clientInfo.updateOtherReserve(id, itemId, data),
    params: { type: data.type },
  }),
)

export const DELETE_CLIENT_RESERVE_REQUEST = `${prefix}/DELETE_CLIENT_RESERVE_REQUEST`
export const DELETE_CLIENT_RESERVE_SUCCESS = `${prefix}/DELETE_CLIENT_RESERVE_SUCCESS`
export const DELETE_CLIENT_RESERVE_FAILURE = `${prefix}/DELETE_CLIENT_RESERVE_FAILURE`

export const deleteClientReserve = createAction(
  (id: string, itemId: string, type: CollateralTypes) => ({
    type: [
      DELETE_CLIENT_RESERVE_REQUEST,
      DELETE_CLIENT_RESERVE_SUCCESS,
      DELETE_CLIENT_RESERVE_FAILURE,
    ],
    promise: (api: IApi) => api.clientInfo.deleteOtherReserve(id, itemId),
    params: { type },
  }),
)

const SEND_SIGN_REMINDER = createRequestTypes(prefix, 'SEND_SIGN_REMINDER')

export const sendSignReminder = createAction((id: string) => ({
  type: SEND_SIGN_REMINDER,
  promise: (api: IApi) => api.bbc.sendSignReminder(id),
}))

const TOGGLE_SIGN_REMINDER = createRequestTypes(prefix, 'TOGGLE_SIGN_REMINDER')

export const toggleSignReminder = createAction((id: string) => ({
  type: TOGGLE_SIGN_REMINDER,
  promise: (api: IApi) => api.bbc.toggleSignReminder(id),
}))

const RETRY_HISTORICAL_DATA = createRequestTypes(prefix, 'RETRY_HISTORICAL_DATA')

export const retryHistoricalData = createAction((id: string) => ({
  type: RETRY_HISTORICAL_DATA,
  promise: (api: IApi) => api.bbc.retryHistoricalData(id),
}))

const STOP_PRE_PROCESSING = createRequestTypes(prefix, 'STOP_PRE_PROCESSING')

export const stopPreProcessing = createAction((id: string) => ({
  type: STOP_PRE_PROCESSING,
  promise: (api: IApi) => api.bbc.stopPreProcessing(id),
}))

const LIST_FOREIGN_COUNTRIES_DROPDOWN = createRequestTypes(
  prefix,
  'LIST_FOREIGN_COUNTRIES_DROPDOWN',
)

export const [
  LIST_FOREIGN_COUNTRIES_DROPDOWN_REQUEST,
  LIST_FOREIGN_COUNTRIES_DROPDOWN_SUCCESS,
  LIST_FOREIGN_COUNTRIES_DROPDOWN_FAILURE,
] = LIST_FOREIGN_COUNTRIES_DROPDOWN

export const listForeignCountriesDropdown = createAction(() => ({
  type: LIST_FOREIGN_COUNTRIES_DROPDOWN,
  promise: (api: IApi) =>
    api.option.getDropdownOptions({
      tableName: 'Inventory_Ineligibility_Categories',
      fieldName: 'Foreign_Country',
    }),
}))

const ADD_FOREIGN_COUNTRY_DROPDOWN = createRequestTypes(prefix, 'ADD_FOREIGN_COUNTRY_DROPDOWN')

export const [
  ADD_FOREIGN_COUNTRY_DROPDOWN_REQUEST,
  ADD_FOREIGN_COUNTRY_DROPDOWN_SUCCESS,
  ADD_FOREIGN_COUNTRY_DROPDOWN_FAILURE,
] = ADD_FOREIGN_COUNTRY_DROPDOWN

export const addForeignCountryDropdown = createAction((country: string) => ({
  type: ADD_FOREIGN_COUNTRY_DROPDOWN,
  promise: (api: IApi) =>
    api.option.addDropdownOption({
      tableName: 'Inventory_Ineligibility_Categories',
      fieldName: 'Foreign_Country',
      validEntry: country,
    }),
}))
